"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
 * A class to represent the the options that are passed to the MwChartNSeriesChartOptions.tooltipFormatter
 * @param {object} options - See below
 * @param {number[]} options.hiddenSeriesIndices - An array of hidden series indices
 * @param {object} options.series - The Series object from Highcharts
 * @param {object} options.point - The Point object from Highcharts
 *
 * @property {number[]} options.hiddenSeriesIndices - An array of hidden series indices
 * @property {string} key - Key name of the point triggering the tooltip
 * @property {number} keyIndex - Key index of the point triggering the tooltip
 * @property {number} percentage - The percentage value of the point triggering the tooltip
 * @property {string} seriesName - Name of the series of the point triggering the tooltip
 * @property {number} value - Value of the point triggering the tooltip
 */
var MwChartStackedPercentageColumnTooltipOptions = function MwChartStackedPercentageColumnTooltipOptions(_ref) {
  var hiddenSeriesIndices = _ref.hiddenSeriesIndices,
      series = _ref.series,
      point = _ref.point;
  (0, _classCallCheck2.default)(this, MwChartStackedPercentageColumnTooltipOptions);
  this.hiddenSeriesIndices = hiddenSeriesIndices;
  this.key = point.category;
  this.keyIndex = point.x;
  this.percentage = point.percentage;
  this.seriesName = series.name;
  this.value = point.y;
  Object.freeze(this);
};

exports.default = MwChartStackedPercentageColumnTooltipOptions;